<script setup lang="ts">
  import { Loader2 } from 'lucide-vue-next';
  import { useTrainingMatrixGeneratedReport } from '../model/useTrainingMatrixGeneratedReport';
  import TrainingMatrixReportView from './TrainingMatrixReportView.vue';

  const { loading, positions, revisionNumber } = useTrainingMatrixGeneratedReport();
</script>

<template>
  <div
    data-testid="training-matrix-generate-report-page"
    class="p-6"
  >
    <div
      v-if="loading"
      class="flex justify-center py-12"
      data-testid="training-matrix-generate-report-loading"
    >
      <Loader2 class="h-6 w-6 animate-spin text-[var(--theme-secondary-ink)]" />
    </div>

    <TrainingMatrixReportView
      v-else
      :positions="positions"
      :revision-number="revisionNumber"
    />
  </div>
</template>
